const isNaN = Number.isNaN;
const VOLUME_VALUE = "player_volume";
const DEFAULT_VOLUME_VALUE = 1;

/**
 * @param {string | number} value
 */
export const getValidVolumeValue = (value) => {
  if (typeof value === "string") {
    const parsedValue = parseFloat(value);

    if (isNaN(parsedValue)) {
      return DEFAULT_VOLUME_VALUE;
    }

    value = parsedValue;
  }

  if (typeof value !== "number") {
    return DEFAULT_VOLUME_VALUE;
  }

  return Math.min(Math.abs(value), DEFAULT_VOLUME_VALUE);
};

// TODO: Использовать эту функцию только с throttle
export const setVolumeValue = (value) => {
  window.localStorage.setItem(VOLUME_VALUE, getValidVolumeValue(value));
};

export const getVolumeValue = () => {
  return getValidVolumeValue(window.localStorage.getItem(VOLUME_VALUE));
};
